'use client';
import { createContext, PropsWithChildren, useState } from 'react';

import { MODALS_DEFAULT_STATE } from '@/constant/modals';
import { ModalNames, ModalsCtxData, ModalsState } from '@/types/modals';

export const ModalsContext = createContext<ModalsCtxData | null>(null);

export function ModalsContextProvider({ children }: PropsWithChildren) {
  const [openState, setOpenState] = useState<ModalsState>(MODALS_DEFAULT_STATE);
  const makeStateUpdateFn = (switchTo: boolean) => (modalName: ModalNames) =>
    setOpenState({ ...openState, [modalName]: switchTo });
  return (
    <ModalsContext.Provider
      value={{ closeModal: makeStateUpdateFn(false), modalsState: openState, openModal: makeStateUpdateFn(true) }}
    >
      {children}
    </ModalsContext.Provider>
  );
}
